import React, {useState} from "react";


const getStrokes = (props, chartTheme)=>{
    const strokeColor = props?.stroke ??  chartTheme === "light" ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)';
    return {
        normal: {
            stroke: props?.dotted ? {
                dash: '2 2',
                color: strokeColor
            } : `${props?.thickness??1} ${strokeColor}`,

        },
        selected: {
            stroke: `4 ${strokeColor}`
        }
    }
}



const getFills = (props, chartTheme)=> {
    const fillColor = props?.fill ?? chartTheme === "light" ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)';
    const selectedFillColor = props?.selectedFill ?? 'rgba(0, 0, 0, 0.5)';
    return {
        normal: {
            fill: fillColor
        },
        selected: {
            fill: selectedFillColor
        }
    }
}

const useAnnotations = ({controller, chartTheme})=>{
    const [activeController, setActiveController] = useState(controller);
    const annotationConfig = {
        line: ['x1', 'y1', 'x2', 'y2'],
        verticalRange: ['x1', 'x2'],
        rectangle: ['x1', 'y1', 'x2', 'y2'],
        // Add more types as needed
    };

    const getAnnotationPoints = (annotation, type) => {
        const points = {};
        annotationConfig[type].forEach(anchor => {
            points[anchor] = annotation[anchor]();
        });
        return points;
    };

    const setAnnotationPoints = (annotation, points) => {
        const type = annotation.getType();
        const [x1, x2, x3] = [
            annotation.xAnchor(),
            annotation?.secondXAnchor?.(),
            annotation?.thirdXAnchor?.()
        ];
        const [y1, y2, y3] = [
            annotation.valueAnchor(),
            annotation?.secondValueAnchor?.(),
            annotation?.thirdValueAnchor?.()
        ];
        console.log('x1, x2, x3', x1, x2, x3);
        console.log('y1, y2, y3', y1, y2, y3);

    };



    const handleAnnotationSettings = (annotation, props)=>{
        annotation.allowEdit(props?.allowEdit??true)
        return annotation
    }


    const setVerticalLine = ({date, ...props})=> {
        const vline = activeController?.current.verticalLine({
            xAnchor: date,
            ...getStrokes(props, chartTheme)
        });
        return handleAnnotationSettings(vline, props)
    }


    const setVerticalRange = ({dates, ...props})=>{
        const vrange = activeController?.current.verticalRange({
            xAnchor: dates[0],
            secondXAnchor: dates[1],
            ...getFills(props, chartTheme)
        });
        return handleAnnotationSettings(vrange, props)
    }

    const drawLineSegment = ({x1, x2, y1, y2})=>{
        const segment = activeController?.current.line?.({
            xAnchor: x1,
            valueAnchor: y1,
            secondXAnchor: x2,
            secondValueAnchor: y2
        });
        return segment

    }

    const setEllipse = ({xAnchor, secondXAnchor, valueAnchor, secondValueAnchor})=>{
        console.log('xAnchor, secondXAnchor, valueAnchor, secondValueAnchor', xAnchor, secondXAnchor, valueAnchor, secondValueAnchor)
        const ellipse = activeController?.current.ellipse({
            xAnchor,
            secondXAnchor,
            valueAnchor,
            secondValueAnchor,
            ...getFills({}),
            ...getStrokes({}, chartTheme)
        });
        return ellipse
    }

    const setHorizontalLine = ({ value, ...props }) => {
        const hline = controller?.current.horizontalLine({
            valueAnchor: value,
            ...getStrokes(props, chartTheme),
        });
        console.log("HLINE HERE ", hline)
        return handleAnnotationSettings(hline, props);
    };

    const setHorizontalRange = ({ values, ...props }) => {
        const hrange = activeController?.current.horizontalRange({
            valueAnchor: values[0],
            secondValueAnchor: values[1],
            ...getFills(props, chartTheme),
        });
        return handleAnnotationSettings(hrange, props);
    };

    const startAnnotation = (type, props) => {
        activeController?.current.startDrawing(type);
    };

    const removeAnnotation = (annotation) => {
        activeController?.current.removeAnnotation(annotation);
    }


    return {
        setVerticalLine, setHorizontalLine,
        setVerticalRange, setHorizontalRange,
        setEllipse,
        drawLineSegment,
        startAnnotation,
        removeAnnotation,
        getAnnotationPoints,
        setAnnotationPoints,
        setActiveController,
        activeController
    }
}

export default useAnnotations;